import React, { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { RouterProps } from 'react-router';
import { SubPage, Tab } from '@symfa-inc/providence-verizon-types';
import { Spin } from 'antd';
import { SiteInformation } from '@client/pages/site/components';
import { EditablePage } from '@shared/components';
import { SiteSelectors, UserSelectors } from '@store/selectors';

export const SiteInformationTab: FC<RouterProps> = ({
  history,
}: PropsWithChildren<RouterProps>) => {
  const permissions = useSelector(UserSelectors.getSitePermissions('browse'));
  const {
    currentSite,
    activeOrAuthorizedProjectsCount,
    hasActiveOrAuthorizedProjects,
  } = useSelector(SiteSelectors.getSiteInformationTabInfo);
  const isLoading = useSelector(
    SiteSelectors.getTabLoadingState('information'),
  );
  const isDataLoaded = useSelector(
    SiteSelectors.getTabLoadedState('information'),
  );
  const canEdit = useSelector(
    UserSelectors.canEdit('site', SubPage.SiteBrowse, Tab.SiteInformation),
  );

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-site-information-tab loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <EditablePage
      permissions={permissions}
      editableComponent={SiteInformation}
      data={{
        ...currentSite,
        activeOrAuthorizedProjectsCount,
        hasActiveOrAuthorizedProjects,
      }}
      history={history}
      canUserEdit={canEdit && currentSite.isSiteOn}
    />
  );
};
